var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("line", {
      staticClass: "ls",
      attrs: { x1: "25", y1: "33.4", x2: "7.9", y2: "16.6" },
    }),
    _vm._v(" "),
    _c("line", {
      staticClass: "ls",
      attrs: { x1: "25", y1: "33.4", x2: "42.1", y2: "16.6" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }